import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import WheelLoading from 'components/loading/wheel_loading'
import DotsLoading from 'components/loading/dots_loading'

import styles from './full_screen_loading.scss'

class FullScreenLoading extends PureComponent {

	render() {
		return (
			<div styleName='wrapper'>
				<div
					styleName={classNames(
						'veil',
						this.props.isTransparent ? 'veil--transparent' : 'veil--opaque'
					)}
				/>
				<div styleName='container'>
					<div styleName='container-loading'>
						{ this.props.animation === 'wheel' &&
							<WheelLoading />
						}
						{ this.props.animation === 'dots' &&
							<DotsLoading />
						}
					</div>
					{ this.props.text &&
						<p styleName='container-text'>
							{this.props.text}
						</p>
					}
				</div>
			</div>
		)
	}

}

FullScreenLoading.propTypes = {
	text: PropTypes.string,
	animation: PropTypes.oneOf(['wheel', 'dots']),
	isTransparent: PropTypes.bool,
}

FullScreenLoading.defaultProps = {
	text: '',
	animation: 'wheel',
	isTransparent: true,
}

export default CSSModules(FullScreenLoading, styles, {allowMultiple: true})
